export default __webpack_public_path__ + "static/media/gif_appel.a40aef27.gif";